import { ApiType } from "@gymflow/common";
import {
  CalculateChangeSubscriptionPriceNewRequestBody,
  CalculateChangeSubscriptionPriceNewResponseBody,
} from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export const useQueryMemberCalculateProRataForChangingSubscription = (
  {
    api,
    membershipId,
    subscriptionId,
  }: {
    api: ApiType;
  } & CalculateChangeSubscriptionPriceNewRequestBody,
  opts?: Omit<
    UseQueryOptions<CalculateChangeSubscriptionPriceNewResponseBody>,
    "queryKey"
  >,
) =>
  useQuery({
    queryKey: memberQueryKeys.calculateChangeSubscriptionPrice({
      membershipId,
      subscriptionId,
    }),
    queryFn: async () =>
      (
        await api.memberApi.calculateChangeSubscriptionPrice({
          membershipId,
          subscriptionId,
        })
      ).data,
    ...opts,
  });
